const es = {
  nav: {
    vista3d: "Vista 3D",
    videocam: "Video Cam",
    smartdomo: "SmartDomo",
    reportSensori: "Informe Sensores",
    apparati: "Aparatos",
    calendario: "Calendario",
    manutenzioni: "Mantenimiento",
    ticket: "Tickets",
    assistente: "Asistente",
    inventario: "Inventario",
    veicoli: "Vehiculos",
    setup: "Config",
    utenti: "Usuarios",
  },
  header: {
    title: "SmartDomo",
    subtitle: "Gestion Inteligente de Edificios",
    admin: "Administrador",
    user: "Usuario",
    logout: "Cerrar sesion",
  },
  auth: {
    title: "Iniciar Sesion",
    subtitle: "Ingrese sus credenciales para continuar",
    username: "Usuario",
    password: "Contrasena",
    login: "Iniciar Sesion",
    loggingIn: "Iniciando sesion...",
    error: "Credenciales invalidas",
    userNotFound: "Usuario no encontrado",
    wrongPassword: "Contrasena incorrecta",
    copyright: "SmartDomo - Gestion Inteligente de Edificios",
  },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    search: "Buscar",
    filter: "Filtrar",
    close: "Cerrar",
    confirm: "Confirmar",
    loading: "Cargando...",
    noData: "Sin datos disponibles",
    actions: "Acciones",
    status: "Estado",
    name: "Nombre",
    description: "Descripcion",
    category: "Categoria",
    date: "Fecha",
    notes: "Notas",
    details: "Detalles",
    back: "Atras",
    next: "Siguiente",
    previous: "Anterior",
    all: "Todos",
    active: "Activo",
    inactive: "Inactivo",
    online: "En linea",
    offline: "Desconectado",
    yes: "Si",
    no: "No",
    or: "o",
    of: "de",
    total: "Total",
    export: "Exportar",
    import: "Importar",
    download: "Descargar",
    upload: "Subir",
    refresh: "Actualizar",
    error: "Error",
    success: "Exito",
    warning: "Advertencia",
    info: "Info",
  },
  dashboard: {
    title: "Panel SmartDomo",
    devices: "Dispositivos",
    totalDevices: "Dispositivos Totales",
    onlineDevices: "Dispositivos En Linea",
    offlineDevices: "Dispositivos Desconectados",
    warnings: "Advertencias",
    consumption: "Consumo",
    dailyConsumption: "Consumo Diario",
    monthlyConsumption: "Consumo Mensual",
    realTimeConsumption: "Consumo en Tiempo Real",
    energyMonitor: "Monitor de Energia",
    temperature: "Temperatura",
    humidity: "Humedad",
    power: "Potencia",
    voltage: "Voltaje",
    current: "Corriente",
    battery: "Bateria",
    doorState: "Estado de la Puerta",
    open: "ABIERTA",
    closed: "CERRADA",
    on: "ENCENDIDO",
    off: "APAGADO",
    switchOn: "encender",
    switchOff: "apagar",
    clickTo: "clic para",
    changingState: "Cambiando estado...",
    lastMovement: "Ultimo movimiento",
    today: "Hoy",
    month: "Mes",
    maintenance: "Mantenimiento",
    alerts: "Alertas",
    sensors: "Sensores",
    monitoredSensors: "Sensores Monitoreados",
    connectedIntegrations: "Integraciones Conectadas",
    systemStatus: "Estado del Sistema",
  },
  appliances: {
    title: "Gestion de Aparatos",
    addNew: "Nuevo Aparato",
    editAppliance: "Editar Aparato",
    brand: "Marca",
    model: "Modelo",
    serialNumber: "Numero de Serie",
    position: "Ubicacion",
    purchaseDate: "Fecha de Compra",
    warrantyExpiry: "Vencimiento Garantia",
    purchaseCost: "Costo de Compra",
    currentValue: "Valor Actual",
    consumption: "Consumo por Hora (kW)",
    dailyUsage: "Horas de Uso Diario",
    smartPlug: "Enchufe Inteligente",
    provider: "Proveedor",
    noAppliances: "Ningun aparato registrado",
    linkedDevice: "Dispositivo Vinculado",
    invoice: "Factura",
    documents: "Documentos",
    manual: "Manual",
    photos: "Fotos",
    videos: "Videos",
    instructions: "Instrucciones",
    serviceCenter: "Centro de Servicio",
    other: "Otro",
    climate: "Clima/Calefaccion",
    kitchen: "Cocina",
    lighting: "Iluminacion",
    security: "Seguridad",
    entertainment: "Entretenimiento",
    cleaning: "Limpieza",
    garden: "Jardin",
    general: "General",
    warranty: "Garantia",
    warrantyActive: "En Garantia",
    warrantyExpired: "Garantia Vencida",
    deleteConfirm: "Esta seguro de que desea eliminar este aparato?",
  },
  maintenance: {
    title: "Gestion de Mantenimiento",
    addNew: "Nuevo Mantenimiento",
    editMaintenance: "Editar Mantenimiento",
    type: "Tipo",
    scheduled: "Programado",
    completed: "Completado",
    inProgress: "En Progreso",
    pending: "Pendiente",
    cancelled: "Cancelado",
    priority: "Prioridad",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    assignedTo: "Asignado a",
    dueDate: "Fecha Limite",
    completedDate: "Fecha de Finalizacion",
    cost: "Costo",
    noMaintenance: "Sin registros de mantenimiento",
    appliance: "Aparato",
    history: "Historial",
    deleteConfirm: "Esta seguro de que desea eliminar este registro?",
  },
  tickets: {
    title: "Gestion de Tickets",
    newTicket: "Nuevo Ticket",
    editTicket: "Editar Ticket",
    subject: "Asunto",
    message: "Mensaje",
    openTicket: "Abrir Ticket",
    closeTicket: "Cerrar Ticket",
    resolved: "Resuelto",
    open: "Abierto",
    closed: "Cerrado",
    inProgress: "En Progreso",
    noTickets: "No se encontraron tickets",
    priority: "Prioridad",
  },
  calendar: {
    title: "Calendario de Mantenimiento",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    day: "Dia",
    noEvents: "Sin eventos",
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    days: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
  },
  sensors: {
    title: "Informe de Sensores",
    temperature: "Temperatura",
    humidity: "Humedad",
    energy: "Energia",
    noData: "Sin Datos Historicos",
    collectData: "Recopilar Datos",
    collecting: "Recopilando...",
    lastHour: "Ultima Hora",
    last24h: "Ultimas 24h",
    last7d: "Ultimos 7 Dias",
    last30d: "Ultimos 30 Dias",
    chart: "Grafico",
    table: "Tabla",
    sensorType: "Tipo de Sensor",
    readings: "Lecturas",
    average: "Promedio",
    min: "Minimo",
    max: "Maximo",
  },
  vehicles: {
    title: "Seguimiento de Vehiculos",
    noVehicles: "No se encontraron vehiculos",
    speed: "Velocidad",
    lastUpdate: "Ultima Actualizacion",
    plateNumber: "Placa",
    moving: "En Movimiento",
    stopped: "Detenido",
    engineOn: "Motor Encendido",
    engineOff: "Motor Apagado",
  },
  matterport: {
    title: "Espacios 3D",
    pois: "POI",
    sensors: "Sensores",
    spaces: "Espacios",
    addSpace: "Espacio",
    goToPoi: "Ir al POI",
    syncCloud: "Sync Cloud",
    sdkConnected: "SDK Conectado",
    sdkDisconnected: "SDK Desconectado",
    liveData: "Datos en Vivo",
    linkedDevice: "Vinculado",
    notSynced: "No sincronizado",
    noSensorLinked: "Sin sensor vinculado",
    navigating: "Navegando...",
    destination: "Destino alcanzado!",
  },
  setup: {
    title: "Configuracion de Propiedad",
    propertyName: "Nombre de Propiedad",
    address: "Direccion",
    integrations: "Integraciones",
    connected: "Conectado",
    disconnected: "Desconectado",
    connect: "Conectar",
    disconnect: "Desconectar",
    matterportSpaceId: "Matterport Space ID",
    matterportSdkKey: "Matterport SDK Key",
    saveChanges: "Guardar Cambios",
    saving: "Guardando...",
    tokenExpired: "Token expirado",
    reconnect: "Reconectar",
  },
  users: {
    title: "Gestion de Usuarios",
    addUser: "Nuevo Usuario",
    editUser: "Editar Usuario",
    username: "Nombre de Usuario",
    email: "Correo",
    role: "Rol",
    admin: "Administrador",
    user: "Usuario",
    password: "Contrasena",
    fullName: "Nombre Completo",
    deleteConfirm: "Esta seguro de que desea eliminar este usuario?",
  },
  videocam: {
    title: "Gestion de Camaras",
    liveView: "Vista en Vivo",
    snapshot: "Captura",
    refreshing: "Actualizando...",
    noCameras: "Sin camaras configuradas",
    lastCapture: "Ultima Captura",
  },
  assistant: {
    title: "Chat Asistente",
    placeholder: "Escribe un mensaje...",
    send: "Enviar",
    thinking: "Pensando...",
    welcome: "Asistente SmartBuilding",
    description: "Pregunta lo que quieras sobre tus aparatos, mantenimiento o configuracion.",
  },
  language: {
    it: "Italiano",
    en: "English",
    fr: "Francais",
    es: "Espanol",
    select: "Idioma",
  },
};

export default es;
